export default {
      id: "engine-usage",
      viewBox: "0 0 75 57",
      url: __webpack_public_path__ + "img/icons.svg#engine",
      toString: function () {
        return this.url;
      }
    }